import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const BadgeComponent = React.lazy(() => import("../Components/RootComponents/BadgeComponent"));
const BadgePage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <BadgeComponent />
      </Suspense>
    </Fragment>
  );
};

export default BadgePage;
